<template>
  <v-list class="pa-0">
    <v-list-item class="specialmarg" @click="goTo()">
      <v-list-item-icon class="mr-4">
        <v-btn icon>
          <avatar :color="'red'" :fullname="fullname">
          </avatar>
        </v-btn>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-text="fullname" />
        <v-list-item-subtitle v-text="emailText" />
      </v-list-item-content>
      <v-list-item-action>
        <action-menu :actionList="actionlist" :parentcontext="thiscontext">
        </action-menu>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import Avatar from "@/components/Buttons/Avatar.vue";

export default {
  components: { ActionMenu, Avatar },

  data() {
    return {
      thiscontext: this,
      actionlist: [
        { title: this.$t('servicesystem.pages.page_titles.my_page_my_account'), icon: "mdi-chevron-right", hovercolor: "primary", method: "goTo" },
        { title: this.$t('servicesystem.pages.page_titles.admin_private_settings'), icon: "mdi-chevron-right", hovercolor: "primary", method: "goToSiteSettings" },
        { title: this.$t('servicesystem.common_objects.fallbackterms.old_site'), icon: "mdi-web-sync ", iconsize: 18, hovercolor: "secondary", method: "backToOld" },
        { title: this.$t('servicesystem.common_objects.fallbackterms.change_portal'), icon: "mdi-keyboard-tab", iconsize: 16, hovercolor: "secondary", method: "changePortal" },
        { title: this.$t('servicesystem.common_objects.commonterms.logout'), icon: "mdi-logout-variant", iconsize: 18, hovercolor: "error", method: "logout" },
      ],
    };
  },

  mounted() { },

  methods: {
    goTo() {
      var target = this.isPadBool ? "MyPage" : "MyAccount";
      if (this.$route.name != target) {
        this.$router.push({ name: target });
      }
    },
    goToSiteSettings() {
      if (this.$route.name != "SiteSettings") {
        this.$router.push({ name: "SiteSettings" });
      }
    },
    changePortal() {
      window.location.href = window.location.origin;
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },

  computed: {
    extended() {
      return this.$store.getters["navstore/Extended"];
    },

    userInfo() {
      return this.$store.getters["userInfo"];
    },

    fullname() {
      return this.userInfo.Name;
    },

    emailText() {
      return this.userInfo && this.userInfo.EmailAdress ? this.userInfo.EmailAdress : "???";
    },
  },
};
</script>

<style>
.specialmarg {
  padding-left: 16px !important;
}

@media only screen and (max-width: 1400px) and (min-width: 1000px) {
  .specialmarg {
    padding-left: 8px !important;
    padding-right: 12px !important;
  }

  .specialmarg .v-list-item__icon {
    margin: 8px 0;
    margin-right: 8px !important;
  }

  .specialmarg .v-avatar {
    transform: scale(0.80) !important;
  }

  .specialmarg .v-list-item__content {
    padding: 4px 0;
  }

  .specialmarg .v-list-item__content .v-list-item__title,
  .specialmarg .v-list-item__content .v-list-item__subtitle {
    margin-bottom: 0px;
  }
}
</style>
